export default "__VITE_ASSET__70372938__"